<template>
  <div class="card">
    <div class="card-body">
      <h4>{{ "customer" | t | titlecase }}</h4>
      <hr />
      <div v-for="(value, key) in customerInfo" :key="key" class="mb-2 row">
        <div class="col-md-4">
          <strong>{{ key | t | titlecase }}</strong>
        </div>
        <div class="col-md-8">
          <component
            :is="value.component"
            v-bind="value.props"
            v-if="value.component"
          ></component>
          <span v-else>{{ applyFilter(value.text, value.filter) }}</span>
          <div
            v-if="key === 'onboarding_status' && showCompleteOnboardingButton"
          >
            <button class="mt-2 btn btn-success btn-sm" @click="onboard">
              <i class="fa fa-check"></i> {{ "complete_onboarding" | t }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    customer: Object,
    thirdPartyManaged: Boolean,
  },
  computed: {
    agreedDPA() {
      return !!this.customer?.data_processing_agreement_accepted_version;
    },
    showCompleteOnboardingButton() {
      return (
        this.customer.onboarding_status === "migrating" ||
        this.customer.onboarding_status === "onboarding"
      );
    },
    customerInfo() {
      return {
        onboarding_status: {
          component: "onboarding-status",
          props: { status: this.customer.onboarding_status },
          text: this.customer.onboarding_status,
        },
        tenant_name: { text: this.customer.tenant_name },
        company_name: { text: this.customer.name },
        vat_no: {
          text: this.customer.vat_no,
          component: "customer-vat-status",
          props: { customer: this.customer },
          condition: this.customer.vat_validation_status,
        },
        ean_no: { text: this.customer.ean_no },
        customer_reference: { text: this.customer.customer_reference },
        address_1: { text: this.customer.address_1 },
        address_2: {
          text: this.customer.address_2,
          condition: this.customer.address_2,
        },
        city: { text: `${this.customer.zip} ${this.customer.city}` },
        country: { text: this.customer.country_code },
        state: {
          text: this.customer.state,
          condition: this.customer.state && this.customer.state.length > 0,
        },
        ext_ref: {
          text: this.customer.ext_ref,
          condition: !this.thirdPartyManaged,
        },
        login_method: { text: this.customer.login_method, filter: "titlecase" },
        two_factor_enabled: {
          text: this.customer.require_2fa,
          filter: "titlecase",
        },
        dpa_accepted: { text: this.agreedDPA, filter: "titlecase" },
        default_ship_page: {
          text: this.customer.default_ship_page,
          filter: "titlecase",
        },
      };
    },
  },
  methods: {
    onboard() {
      this.$emit("onboard");
    },
    applyFilter(text, filter) {
      if (!filter) return text;
      return this.$options.filters[filter](text);
    },
  },
};
</script>